<template>
    <div
        class="progress-bar"
        :class="{ 'progress-bar--active': active }"
    >
        <div class="progress-bar__inner"></div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';

const props = defineProps({
    progressBorder: {
        type: Object,
        required: true,
    },
    progressBackground: {
        type: Object,
        required: true,
    },
    progressActiveBackground: {
        type: Object,
        required: true,
    },
});

const active = ref(false);

onMounted(() => {
    setTimeout(() => {
        active.value = true;
    }, 100);
});
</script>

<style lang="scss" scoped>
@use 'zoe-molecule-lefty-progress';

@layer molecule {
    .progress-bar {
        --border: v-bind('props.progressBorder');
        --background: v-bind('props.progressBackground');
        --active-background: v-bind('props.progressActiveBackground');
    }
}
</style>
